import { render, staticRenderFns } from "./DataQualityManager.vue?vue&type=template&id=f3d4b762&lang=pug"
import script from "./DataQualityManager.vue?vue&type=script&lang=ts"
export * from "./DataQualityManager.vue?vue&type=script&lang=ts"
import style0 from "./DataQualityManager.vue?vue&type=style&index=0&id=f3d4b762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports